exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".AgencyUsersAnalyticsHome_paper__1DVf2 {\n  margin-bottom: 24px;\n  display: -webkit-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n          flex-direction: column;\n  padding: 15px; }\n\n.AgencyUsersAnalyticsHome_filterPaper__3XjK3 {\n  width: -webkit-fit-content;\n  width: -moz-fit-content;\n  width: fit-content;\n  margin-left: auto; }\n", ""]);

// exports
exports.locals = {
	"paper": "AgencyUsersAnalyticsHome_paper__1DVf2",
	"filterPaper": "AgencyUsersAnalyticsHome_filterPaper__3XjK3"
};